module.exports = __webpack_public_path__ + "public/img/ptz-icon1.63c96fa4.svg";